<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="formData" :rules="rules" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="planType" label="车辆类型" @change="onChangeIsOiltanker">
              <el-select v-model="formData.planType" placeholder="请选择计划类型">
                <el-option v-for="item of planTypeList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.planType === '2'">
            <el-form-item prop="isOiltanker" label="是否油轮">
              <el-radio-group v-model="formData.isOiltanker">
                <el-radio label="0">否</el-radio>
                <el-radio label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车牌号" :prop="formData.isOiltanker === '1' ? '' : 'vehicleKey'">
              <el-input v-model="formData.vehicleKey" placeholder="请输入车牌号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="挂车号" prop="vehicleGph">
              <el-input v-model="formData.vehicleGph" placeholder="请输入挂车号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机姓名" prop="driverName">
              <el-input v-model="formData.driverName" placeholder="请输入司机姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机身份证" prop="driverKey">
              <el-input v-model="formData.driverKey" placeholder="请输入司机身份证" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机手机号" prop="driverMobile">
              <el-input v-model="formData.driverMobile" placeholder="请输入司机手机号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机照片" prop="driverPhotoUrl">
              <!-- 单张照片直接保存完整 URL，与附件独立维护 -->
              <media-upload v-model="formData.driverPhotoUrl" :multiple="false" :limit="1" accept=".jpg,.jpeg,.png" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="附件" prop="fileList">
              <file-upload v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="submit" class="global-button">保存</el-button>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { validIDCard, validPhoneNumber } from '@/utils/validator'
import { planType } from '@/utils/dict'
import { mapToObjectArray } from '@/utils/utils'

export default {
  name: 'CarManageAdd',
  data() {
    return {
      planTypeList: mapToObjectArray(planType),
      formData: {
        planType: '',
        vehicleKey: '', // 车牌号
        vehicleGph: '', // 挂车号
        driverName: '', // 司机姓名
        isOiltanker: '', // 是否油轮
        driverKey: '', // 司机身份证
        driverMobile: '', // 司机手机号
        driverPhotoUrl: '', // 司机照片完整 URL，空字符串表示移除
        fileList: [] // 附件列表
      },
      rules: {
        planType: [
          { required: true, message: '请选择计划类型' }
        ],
        vehicleKey: [
          { required: true, message: '请输入车牌号' }
          // { pattern: validLicensePlate, message: '请输入正确的车牌号' }
        ],
        driverKey: [{ pattern: validIDCard, message: '请输入正确的司机身份证' }],
        driverMobile: [{ pattern: validPhoneNumber, message: '请输入正确的司机手机号' }]
        // vehicleGph: [{ required: true, message: '请输入挂车号' }]
      }
    }
  },
  computed: {
    vehicleId() {
      return this.$route.query.vehicleId
    }
  },
  created() {
    if (this.vehicleId) {
      this.loadDetails()
    }
  },
  methods: {
    onChangeIsOiltanker(val) {
      if (val === '1') {
        this.formData.isOiltanker = ''
      }
    },
    loadDetails() {
      this.$axios.get(this.$apis.carManage.selectWlVehicleInfoByVehicleId, {
        params: { vehicleId: this.vehicleId }
      }).then(res => {
        this.formData = res
      })
    },
    submit() {
      this.$refs.formData.validate().then(() => {
        let url = this.$apis.carManage.insertWlVehicleInfo
        if (this.vehicleId) {
          url = this.$apis.carManage.updateWlVehicleInfo
        }
        this.$axios.post(url, this.formData).then(res => {
          // this.$store.dispatch('getUserList')
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader {
  width: 95%;
}

.flex-end {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.table-form {

  .el-select,
  .el-input,
  .el-cascader,
  .el-input-number {
    width: 100% !important;
  }

  ::v-deep .el-form-item__label {
    display: none;

    &::before {
      display: none;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}
</style>
